import { useState } from "react";
import { Autocomplete as MuiAutocomplete, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

export function Autocomplete({
  label,
  placeholder,
  loading,
  getOptionLabel,
  options,
  onChange,
  error,
  helperText = "",
  variant = "outlined",
  size,
  required = false,
  showChips = true,
  labelShrink = undefined,
  onFocus = event => event,
  onBlur = event => event,
  ...rest
}) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <StyledMuiAutocomplete
      componentsProps={{
        popper: {
          placement: "bottom-start",
          sx: {
            width: "fit-content !important",
            minWidth: "250px !important",
            maxWidth: "150ch !important",
            "& .MuiAutocomplete-option": {
              wordBreak: "break-word"
            }
          }
        }
      }}
      loading={loading}
      loadingText={"Loading..."}
      onChange={onChange}
      options={options ?? []}
      getOptionLabel={getOptionLabel}
      size={size}
      onFocus={event => {
        setIsFocused(true);
        onFocus(event);
      }}
      onBlur={event => {
        setIsFocused(false);
        onBlur(event);
      }}
      renderTags={showChips ? undefined : () => []}
      renderInput={params => (
        <TextField
          placeholder={placeholder}
          {...params}
          InputLabelProps={{
            ...params.InputLabelProps,
            // Decide to make input label shrink to top of input.
            // Shrink true mean always shrink on. Set as undefined is set default
            shrink: !isFocused && !showChips ? false : undefined
          }}
          variant={variant}
          error={error}
          helperText={helperText}
          label={label}
          required={required}
        />
      )}
      {...rest} // pass extra or override existing properties
    />
  );
}

Autocomplete.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  loading: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  options: PropTypes.array,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  variant: PropTypes.string,
  size: PropTypes.string,
  required: PropTypes.bool,
  popper: PropTypes.elementType,
  showChips: PropTypes.bool,
  labelShrink: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};

const StyledMuiAutocomplete = styled(MuiAutocomplete)`
  .MuiFormLabel-root {
    &:not(.Mui-focused) {
      color: rgba(0, 0, 0, 0.4);
    }
  }
`;
